import { render, staticRenderFns } from "./documents-subpage.vue?vue&type=template&id=521cab18&lang=pug&"
import script from "./documents-subpage.vue?vue&type=script&lang=js&"
export * from "./documents-subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports